
import Vue from "vue";
import SubHeader from "@/views/layout/header/SubHeader.vue";
import Search from "@/components/Search.vue";
import { Component } from "vue-property-decorator";
import MenuFooter from "@/views/layout/footer/MenuFooter.vue";
import api from "@/api";
import TicketModel from "@/models/createTicket/TicketModel";
import TextFloating from "@/components/input/TextFloating.vue";
import FileInput from "@/components/input/FileInput.vue";

import { ValidationObserver, ValidationProvider } from "vee-validate";
import utils from "@/utils";
import AttachmentModel from "@/models/createTicket/AttachmentModel";
import FeedbackApprovalModel from "@/models/createTicket/FeedbackApprovalModel";
import FeedbackModel from "@/models/createTicket/FeedbackModel";
import SelectAutocomplete from "@/components/input/SelectAutocomplete.vue";
import LoadingOverlay from "@/components/overlay/LoadingOverlay.vue";

@Component({
    components: {
        SubHeader,
        Search,
        MenuFooter,
        FileInput,
        SelectAutocomplete,
        LoadingOverlay,
        ValidationObserver,
        ValidationProvider,
        TextFloating,
    },
})
export default class ListNotification extends Vue {
    mounted() {
        this.getDetailFeedback(this.$route.params.id);
        // this.getActivities(this.$route.params.id);
        this.loadQCUsers();
    }
    utils = utils;
    titlePage = "Assessment Report";
    date = "21/JAN/2022";
    time = "12.30";
    title = "Cake Engine Breaking Down";
    subTitle = "Lorem Ipsum is simply text";
    status = "new";
    isOpen = "0";
    isActiveDesc = false;
    isActiveUser = false;

    step = 0;
    stars: number | null = null;
    approved: number | null = null;
    needcheck: number | null = null;
    note: string | null = null;
    theprocess: boolean = false;
    qcuser: any = null;

    listImage: AttachmentModel[] = [];
    ticket : any =  [];
    tickets : any =  [];
    listQCUsers: any[] = [];

    // activities: any[] = [];

    goToDetail(id: string) {
        this.$router.push("/ticket-activity-view/" + id);
    }
    // getActivities(id) {
    //     return new Promise((resolve, reject) => {
    //         api.ticket
    //             .getActivities(id, 1)
    //             .then((response) => {
    //                 if (response.data.code === 200) {
    //                     this.activities = response.data.data;
    //                     resolve(response);
    //                 }
    //             })
    //             .catch((err: any) => {
    //                 reject(err);
    //                 this.$swal("Error", err?.response?.data?.message, "error");
    //             });
    //     });
    // }

    getDetailFeedback(idTicket: string) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getFeedback(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.ticket = Object.assign({}, response.data.data);
                        this.getDetailTicket(this.ticket?.work_orders_id);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    loadQCUsers() {
        return new Promise((resolve, reject) => {
            api.options
                .getQcUsers()
                .then((response) => {
                    if (response.data.code === 200) {
                        // console.log(response.data.data);
                        this.listQCUsers = response.data.data.map((e: any) => {
                            return {
                                value: e.id,
                                text: e.name,
                            };
                        });
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    getDetailTicket(idTicket: any) {
        return new Promise((resolve, reject) => {
            api.ticket
                .getDetailTask2(idTicket)
                .then((response) => {
                    if (response.data.code === 200) {
                        this.tickets = Object.assign({}, response.data.data);
                        resolve(response);
                    }
                })
                .catch((err: any) => {
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    submitTicket() {
        if (this.theprocess) return;
        this.theprocess = true;
        return new Promise((resolve, reject) => {
            // console.log(this.qcuser == "", this.needcheck);
            if (this.approved === null) {
                this.$swal(
                    "Peringatan",
                    "Harap pilih status approve",
                    "warning"
                );
                this.theprocess = false;
                return;
            }
            if (this.needcheck === null && this.approved == 1) {
                this.$swal(
                    "Peringatan",
                    "Harap pilih QA verification",
                    "warning"
                );
                this.theprocess = false;
                return;
            }
            if ((this.qcuser === null || this.qcuser == "") && this.needcheck) {
                this.$swal("Peringatan", "Harap pilih QC User", "warning");
                this.theprocess = false;
                return;
            }
            if (this.stars === null) {
                this.$swal("Peringatan", "Harap pilih rating", "warning");
                this.theprocess = false;
                return;
            }
            if (this.note === null) {
                this.$swal("Peringatan", "Harap isi catatan", "warning");
                this.theprocess = false;
                return;
            }
            const data: FeedbackApprovalModel = {
                feedback_id: Number(this.$route.params.id),
                user_feedback_note: this.note,
                is_qc: this.needcheck,
                qc_user_id: this.qcuser,
                is_approve: this.approved,
                rating_star: this.stars,
            };
            // console.log(data);
            // return
            api.ticket
                .saveFeedbackApproval(data)
                .then((response) => {
                    this.theprocess = false;
                    if (response.data.code === 200) {
                        this.$router.back();
                    } else {
                        this.$swal(
                            "Peringatan",
                            response.data.message,
                            "warning"
                        );
                    }
                })
                .catch((err: any) => {
                    this.theprocess = false;
                    reject(err);
                    this.$swal("Error", err?.response?.data?.message, "error");
                });
        });
    }

    cekUser() {
        if (this.qcuser !== null) {
            this.isActiveUser = true;
        } else {
            this.isActiveUser = false;
        }
    }
    get colorStatus() {
        return "cl-red";
        // if (this.ticket.status === "new") {
        //     return "cl-red";
        // } else {
        //     return "cl-green-light";
        // }
    }
    get pitaStatus() {
        return "new";
        // if (this.ticket.status === "new") {
        //     return "new";
        // } else {
        //     return "on-progress";
        // }
    }
}
